// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — settings-sip.styled.classic.js, новая — settings-sip.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './settings-sip.styled.classic';
import * as cp from './settings-sip.styled.cp';

export const Buttons = isCp ? cp.Buttons : classic.Buttons;
export const Content = isCp ? cp.Content : classic.Content;
export const Label = isCp ? cp.Label : classic.Label;
export const TypeSelector = isCp ? cp.TypeSelector : classic.TypeSelector;
